export const toFixedIfNecessary = (value, dp = 2) =>
  parseFloat(value).toFixed(dp)
